import {
  SET_LOCATION,
  SET_LUNCH_OPTION,
  SET_LUNCH_NOTES,
  SET_HEALTH_QUESTIONS,
  SET_LAST_ATTENDANCE_RATING,
  RESET_FORM
} from 'actions/account/eci/actionTypes'

const eciForm = (state = {}, action) => {
  switch (action.type) {
    case SET_LOCATION:
      const { location } = action
      return Object.assign({}, state, { location })
    case SET_LUNCH_OPTION:
      const { lunchOption } = action
      return Object.assign({}, state, { lunchOption })
    case SET_LUNCH_NOTES:
      const { lunchNotes } = action
      return Object.assign({}, state, { lunchNotes })
    case SET_LAST_ATTENDANCE_RATING:
      const { lastAttendanceRating } = action
      return Object.assign({}, state, { lastAttendanceRating })
    case SET_HEALTH_QUESTIONS:
      const { healthQuestions } = action
      return Object.assign({}, state, { healthQuestions })
    case RESET_FORM:
      return {
        location: null,
        lunchOption: null,
        lunchNotes: null,
        healthQuestions: null,
        lastAttendanceRating: null,
        lastAttendanceId: null
      }
    default:
      return state
  }
}

export default eciForm
